export default "__VITE_ASSET__CVkFgTuy__"